<div class="card app-tile new-card">
  <div class="card-body app-tile-body p-0">
    <mat-card-title>
      <div
        class="icon-frame new-icon-frame-size"
        >
        <img
          src="{{ card.thumbnailUrl }}"
          class="app-icon card-img"
          alt="app-icon"
          />
        </div>
        <mat-card-title-text>
          <div class="row">
            <div class="col-12 p-0">
              <p
                class="card-text app-name-no-hover card-title"
                style="width: 100%"
                placement="top"
                tt_datatestid="apptile-name-tooltip"
                tt_datapendoid="apptile-name-tooltip"
                tt_arialabel="App tile name tooltip"
                [rw-tooltip]="card?.Name"
                >
                {{ card?.Name }}
              </p>
            </div>
          </div>
        </mat-card-title-text>
      </mat-card-title>
      @if (appIsLink()) {
        <div class="p-flex" style="bottom: 10px; position: absolute">
          <div>
            <app-button id="btnLaunch_{{ card.Name | rnFormatLowercaseNoSpace }}"
              label="LAUNCH"
              buttonStyle="changeSeatCount"
              (clickActionEmitter)="openBrowser()"
              noContentPadding="true"></app-button>
          </div>
        </div>
      }
      @if (!appIsLink()) {
        <div class="p-flex" style="bottom: 10px; position: absolute">
          <div>
            <mat-card-actions>
              <div class="button-container mt-0">
                <div class="uninstall-open-frame pt-0">
                  @if (
                    card.displayType() === 'Installed' ||
                    card.displayType() === 'RemoveError' ||
                    card.displayType() === 'RemoveFailure'
                  ) {
                    <div class="uninstall-open-frame pt-0">
                      <div class="uninstall-link-frame" [class.soloTrashcan]="!canOpen()">
                        <app-button id="btnUninstall_{{ card.Name | rnFormatLowercaseNoSpace }}"
                          [disabled]="linkButtonDisabled"
                          buttonStyle="primary"
                          noContentPadding="true"
                          (clickActionEmitter)="confirmUninstall()"
                          [imgSource]="'rn-trash-2'"
                          [buttonStyle]="'icon'"
                          [tooltip]="getTooltip(card)"
                          [tooltipDisabled]="!getTooltip(card)"
                          [tooltipsPosition]="'top'">
                        </app-button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </mat-card-actions>
          </div>
          <div>
            <mat-card-actions>
              <div class="button-container mt-0">
                <div class="uninstall-open-frame pt-0">
                    @if (
                      card.displayType() === 'Installed' ||
                      card.displayType() === 'RemoveError'
                      ) {
                      <div
                        class="uninstall-open-frame pt-0"
                        >
                        @if (canOpen()) {
                          <app-button
                            id="btnOpen_{{ card.Name | rnFormatLowercaseNoSpace }}"
                            [label]="card.isOpening ? 'OPENING...' : 'OPEN'"
                            [disabled]="card.isOpening"
                            buttonStyle="changeSeatCount"
                            noContentPadding="true"
                            (clickActionEmitter)="open()"
                            [tooltipsPosition]="'top'"
                            >
                          </app-button>
                        }
                      </div>
                    }
                    @else if (
                      card.displayType() === 'Removed' ||
                      card.displayType() === 'InstallError' ||
                      card.displayType() === 'Installing' ||
                      card.displayType() === 'InstallFailure'
                      ) {
                      <div
                        >
                        <div
                          placement="right"
                          tt_datatestid="apptile-installblocked-tooltip"
                          tt_datapendoid="apptile-installblocked-tooltip"
                          tt_arialabel="App tile install blocked tooltip"
                          [rw-tooltip]="card.BlockingFlavorId ? installBlockedTooltipText : ''"
                          >
                          <app-button
                            id="btnInstall_{{ card.Name | rnFormatLowercaseNoSpace }}"
                            label="INSTALL"
                            [disabled]="
                              card.ProvisioningState === 'Installing' ||
                              card.ProvisioningState === 'InstallFailure' ||
                              card.BlockingFlavorId
                            "
                            buttonStyle="changeSeatCount"
                            (clickActionEmitter)="install()"
                            [tooltip]="getTooltip(card)"
                            noContentPadding="true"
                            [tooltipDisabled]="!getTooltip(card)"
                            [tooltipsPosition]="'top'"
                            >
                          </app-button>
                        </div>
                      </div>
                    }
                </div>
              </div>
            </mat-card-actions>
          </div>
        </div>
      }
    </div>
  </div>
